import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';

import {
  startWelcomeTour,
  finishWelcomeTour,
} from 'redux/reducers/onboardingSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

import imgLogo from 'assets/img/logo-new.svg';

import styles from './TourPage.module.less';

export default function TourPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleBack = () => {
    dispatch(finishWelcomeTour());
    navigate(-1);
  };

  const handleNext = () => {
    dispatch(startWelcomeTour());
    navigate('/');
  };

  return (
    <div className={styles.intro}>
      <img className={styles.logo} src={imgLogo} alt="logo" />
      <div className={styles.car}>
        <svg
          width="771"
          height="381"
          viewBox="0 0 771 381"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M0 368.467C0 375.389 172.604 381 385.5 381C598.396 381 771 375.389 771 368.467C771 361.546 598.396 355.963 385.5 355.963C172.604 355.963 0 361.574 0 368.467Z"
              fill="url(#paint0_radial)"
            />
            <path
              d="M243.483 314.319C243.483 314.319 237.167 325.855 223.793 326.225C210.419 326.595 119.821 325.855 119.821 325.855H101.98C101.98 325.855 82.6592 322.522 80.8097 308.024C78.9602 293.526 101.61 255.614 162.132 263.048C222.683 270.454 241.634 280.11 243.483 314.319Z"
              fill="#1A2D6D"
            />
            <path
              d="M637.861 310.958C637.861 310.958 609.635 310.958 592.932 309.106C576.229 307.255 496.756 315.43 487.85 312.069C478.944 308.708 508.65 238.837 574.749 242.938C640.849 247.04 637.491 287.544 637.861 310.958Z"
              fill="#1A2D6D"
            />
            <path
              d="M243.483 314.319C243.483 314.319 237.167 325.855 223.793 326.225C210.419 326.595 119.821 325.855 119.821 325.855H101.98C101.98 325.855 82.6592 322.522 80.8097 308.024C78.9602 293.526 101.61 255.614 162.132 263.048C222.683 270.454 241.634 280.11 243.483 314.319Z"
              fill="url(#paint1_linear)"
            />
            <path
              d="M637.861 310.958C637.861 310.958 609.635 310.958 592.932 309.106C576.229 307.255 496.756 315.43 487.85 312.069C478.944 308.708 508.65 238.837 574.749 242.938C640.849 247.04 637.491 287.544 637.861 310.958Z"
              fill="url(#paint2_linear)"
            />
            <path
              d="M109.435 322.493C109.435 351.86 133.223 375.644 162.531 375.644C191.839 375.644 215.627 351.831 215.627 322.493C215.627 293.154 191.839 269.342 162.531 269.342C133.223 269.342 109.435 293.126 109.435 322.493Z"
              fill="black"
            />
            <path
              className={styles.wheelOne}
              d="M109.435 322.493C109.435 351.86 133.223 375.644 162.531 375.644C191.839 375.644 215.627 351.831 215.627 322.493C215.627 293.154 191.839 269.342 162.531 269.342C133.223 269.342 109.435 293.126 109.435 322.493Z"
              fill="url(#paint3_linear)"
            />
            <path
              d="M132.455 322.493C132.455 339.128 145.914 352.601 162.531 352.601C179.149 352.601 192.607 339.128 192.607 322.493C192.607 305.859 179.149 292.386 162.531 292.386C145.914 292.386 132.455 305.859 132.455 322.493Z"
              fill="white"
            />
            <path
              d="M136.246 322.493C136.246 337.077 148.054 348.898 162.623 348.898C177.191 348.898 189 337.077 189 322.493C189 307.91 177.191 296.089 162.623 296.089C148.054 296.089 136.246 307.91 136.246 322.493Z"
              fill="#CED5DD"
            />
            <path
              d="M36.6201 252.593C36.6201 292.385 42.567 314.318 42.567 314.318H83.399C83.399 314.318 90.4557 304.662 96.4027 293.496C102.35 282.331 112.736 281.22 112.736 281.22C112.736 281.22 195.196 281.989 209.31 281.59C223.423 281.22 226.411 293.496 226.411 293.496L240.524 319.502L493.427 322.493L502.731 317.651C502.731 317.651 508.678 301.643 520.914 281.22C533.178 260.768 561.376 261.509 586.643 265.24C611.911 268.943 621.187 304.633 623.406 311.697C625.626 318.761 641.219 317.28 666.856 317.651C692.465 318.021 691.355 303.893 693.973 297.569C696.591 291.246 696.961 231.031 696.961 231.031C696.961 231.031 696.961 231.031 696.961 231.003C696.563 229.664 683.929 186.283 680.998 176.399C678.01 166.373 669.104 156.318 669.104 156.318L628.642 93.8529L61.5745 90.8906C48.0302 106.699 40.7744 170.076 40.7744 170.076C40.7744 170.076 40.6606 171.272 40.4614 173.408C39.4655 184.204 36.6201 219.438 36.6201 252.593Z"
              fill="#DBAC00"
            />
            <path
              d="M40.4332 173.408L429.177 177.14C429.177 177.14 599.989 178.251 640.109 184.944C679.576 191.553 696.392 229.806 696.904 231.003C696.506 229.664 683.872 186.283 680.941 176.399C677.954 166.373 669.047 156.318 669.047 156.318L628.585 93.8529L61.5179 90.8906C47.9736 106.699 40.7177 170.076 40.7177 170.076C40.7177 170.076 40.6039 171.272 40.4332 173.408Z"
              fill="#EFF6FF"
            />
            <path
              d="M643.438 97.2147L481.903 95.819L171.921 94.1384L68.0338 93.5687L59.1276 93.2839C59.1276 93.2839 67.0948 83.6279 81.2366 77.3044C95.35 70.981 137.491 68.1896 149.556 68.0187C161.62 67.8193 186.888 67.8193 186.888 67.8193L325.205 68.9302L470.407 70.4114C470.407 70.4114 474.875 59.8154 481.561 60.7553C488.248 61.6953 490.838 63.7176 493.256 63.7176C495.675 63.7176 580.896 70.5823 586.473 71.3228C592.05 72.0634 621.927 74.6839 632.341 83.2291C642.699 91.8312 643.438 97.2147 643.438 97.2147Z"
              fill="#EFF6FF"
            />
            <path
              d="M503.613 83.0005C503.613 86.2192 503.443 88.8682 506.687 88.8682H578.534C581.749 88.8682 584.396 86.2476 584.396 83.0005C584.396 79.7533 570.538 77.1328 567.323 77.1328H506.687C503.443 77.1328 503.613 79.7533 503.613 83.0005Z"
              fill="#CED5DD"
            />
            <path
              d="M404.479 83.0005C404.479 86.2192 405.247 88.8682 408.235 88.8682H474.818C477.806 88.8682 478.574 86.2476 478.574 83.0005C478.574 79.7533 477.806 77.1328 474.818 77.1328H408.235C405.219 77.1328 404.479 79.7533 404.479 83.0005Z"
              fill="#CED5DD"
            />
            <path
              d="M303.351 83.0005C303.351 86.2192 304.376 88.8682 307.392 88.8682H373.975C376.963 88.8682 378.016 86.2476 378.016 83.0005C378.016 79.7533 376.991 77.1328 373.975 77.1328H307.392C304.404 77.1328 303.351 79.7533 303.351 83.0005Z"
              fill="#CED5DD"
            />
            <path
              d="M203.932 82.431C203.932 85.6781 204.7 88.2987 207.688 88.2987H274.271C277.259 88.2987 278.312 85.6781 278.312 82.431C278.312 79.2123 277.287 76.5918 274.271 76.5918H207.688C204.7 76.5918 203.932 79.2123 203.932 82.431Z"
              fill="#CED5DD"
            />
            <path
              d="M627.561 304.919C627.561 304.919 626.736 322.494 640.365 325.285C654.023 328.076 684.925 323.063 691.071 323.32C697.189 323.605 710.847 319.987 711.416 311.898C711.985 303.808 707.233 298.254 699.152 298.254C691.071 298.254 693.575 302.982 677.982 303.552C662.389 304.122 636.752 303.552 636.752 303.552C636.752 303.552 627.561 302.128 627.561 304.919Z"
              fill="#1A2D6D"
            />
            <path
              d="M720.322 274.811L717.249 320.243C717.249 320.243 709.168 323.034 705.839 319.958C702.481 316.882 699.437 302.127 702.225 297.655C705.014 293.183 711.131 273.956 711.131 273.956C711.131 273.956 716.965 271.735 720.322 274.811Z"
              fill="#1A2D6D"
            />
            <path
              d="M685.21 246.271C685.21 256.753 688.738 265.241 693.092 265.241C697.445 265.241 700.974 256.753 700.974 246.271C700.974 235.789 697.445 227.301 693.092 227.301C688.738 227.329 685.21 235.817 685.21 246.271Z"
              fill="#EFF6FF"
            />
            <path
              d="M690.417 245.729C690.417 253.99 693.205 260.683 696.648 260.683C700.091 260.683 702.88 253.99 702.88 245.729C702.88 237.469 700.091 230.775 696.648 230.775C693.205 230.775 690.417 237.469 690.417 245.729Z"
              fill="#DBAC00"
            />
            <path
              d="M675.592 213.97C677.186 219.439 680.657 223.227 683.36 222.43C686.035 221.632 686.917 216.562 685.324 211.093C683.73 205.624 680.259 201.836 677.555 202.633C674.881 203.431 673.999 208.501 675.592 213.97Z"
              fill="#EFF6FF"
            />
            <path
              d="M678.722 212.716C679.974 217.017 682.734 220.008 684.839 219.381C686.945 218.755 687.656 214.767 686.376 210.466C685.124 206.165 682.364 203.174 680.258 203.801C678.153 204.427 677.47 208.415 678.722 212.716Z"
              fill="#DF82BE"
            />
            <path
              d="M710.278 278.059C710.278 278.059 712.497 279.91 711.388 282.331C710.278 284.752 707.688 284.183 707.688 284.183C707.688 284.183 698.042 281.961 694.144 286.775C690.246 291.617 690.047 297.542 689.876 299.592C689.677 301.643 689.506 304.435 689.506 304.435C689.506 304.435 686.148 307.767 683.018 303.324C683.018 303.324 683.388 290.506 688.226 283.812C693.006 277.147 710.278 278.059 710.278 278.059Z"
              fill="#1A2D6D"
            />
            <path
              d="M712.896 275.466C712.896 275.466 707.888 266.921 693.205 268.943L693.575 273.586C693.575 273.586 705.839 273.586 709.538 279.539L712.896 275.466Z"
              fill="#1A2D6D"
            />
            <path
              d="M673.23 299.336H636.467C636.467 299.336 628.955 300.162 624.488 293.212C620.02 286.234 615.582 254.731 571.847 255.3C528.113 255.87 499.801 256.411 499.801 256.411L499.687 172.213L597.997 173.039C597.997 173.039 651.206 172.754 665.946 183.094C666.003 183.094 679.632 266.181 673.23 299.336Z"
              stroke="#DBAC00"
              strokeWidth="0.6888"
              strokeMiterlimit="10"
            />
            <path
              d="M673.23 299.336H636.467C636.467 299.336 628.955 300.162 624.488 293.212C620.021 286.234 615.582 254.731 571.848 255.3C528.113 255.87 499.801 256.411 499.801 256.411L499.687 172.213"
              stroke="black"
              strokeWidth="0.6888"
              strokeMiterlimit="10"
            />
            <path
              d="M535.198 203.715H512.719C512.719 203.715 509.361 200.553 506.402 202.035C503.443 203.516 503.613 207.617 505.093 208.728C506.573 209.839 511.58 210.21 513.089 208.899C514.568 207.589 531.669 207.589 531.669 207.589C531.669 207.589 536.307 207.817 535.198 203.715Z"
              fill="#CED5DD"
            />
            <path
              d="M496.756 306.144C496.756 306.144 493.797 311.356 490.809 311.727H262.064C262.064 311.727 255.377 309.875 254.637 305.773L496.756 306.144Z"
              fill="black"
            />
            <path
              d="M511.609 322.493C511.609 351.86 535.397 375.644 564.705 375.644C594.013 375.644 617.801 351.831 617.801 322.493C617.801 293.154 594.013 269.342 564.705 269.342C535.397 269.342 511.609 293.126 511.609 322.493Z"
              fill="black"
            />
            <path
              className={styles.wheelTwo}
              d="M511.609 322.493C511.609 351.86 535.397 375.644 564.705 375.644C594.013 375.644 617.801 351.831 617.801 322.493C617.801 293.154 594.013 269.342 564.705 269.342C535.397 269.342 511.609 293.126 511.609 322.493Z"
              fill="url(#paint4_linear)"
            />
            <path
              d="M534.629 322.493C534.629 339.128 548.088 352.601 564.705 352.601C581.322 352.601 594.781 339.128 594.781 322.493C594.781 305.859 581.322 292.386 564.705 292.386C548.088 292.386 534.629 305.859 534.629 322.493Z"
              fill="white"
            />
            <path
              d="M538.246 322.493C538.246 337.077 550.054 348.898 564.623 348.898C579.191 348.898 591 337.077 591 322.493C591 307.91 579.191 296.089 564.623 296.089C550.026 296.089 538.246 307.91 538.246 322.493Z"
              fill="#CED5DD"
            />
            <path
              d="M668.791 126.752C665.462 126.467 665.718 130.369 665.177 135.126C664.608 139.855 661.279 161.901 661.279 161.901C661.279 161.901 664.068 164.692 665.746 160.22C667.425 155.749 670.214 148.229 670.47 140.994C670.726 133.731 668.791 126.752 668.791 126.752Z"
              fill="black"
            />
            <path
              d="M666.828 185.885C666.828 185.885 672.689 183.948 672.689 175.573C672.689 167.199 667.397 154.951 667.397 154.951L665.718 158.54C665.718 158.54 671.011 167.171 670.442 174.719C669.872 182.239 665.974 183.093 665.974 183.093L666.828 185.885Z"
              fill="#BDCFFF"
            />
            <path
              d="M501.11 165.519H645.374C645.374 165.519 651.235 164.949 652.601 158.825C653.995 152.701 649.272 149.055 649.272 149.055L624.203 106.956C624.203 106.956 625.029 102.484 613.903 103.054C602.749 103.624 513.089 101.943 513.089 101.943C513.089 101.943 501.394 99.9777 501.11 111.713C500.825 123.42 501.11 165.519 501.11 165.519Z"
              fill="#182B71"
            />
            <path
              d="M505.663 161.646H641.276C641.276 161.646 646.768 163.07 648.077 157.316C649.386 151.562 644.947 148.144 644.947 148.144L621.387 110.545C621.387 110.545 622.183 106.358 611.712 106.871C608.639 107.042 599.192 106.985 587.355 106.871C581.522 106.814 575.148 106.729 568.661 106.643C566.043 106.615 563.397 106.558 560.75 106.529C554.234 106.444 547.832 106.33 541.999 106.244C527.715 106.017 516.959 105.817 516.959 105.817C516.959 105.817 505.976 103.994 505.691 114.989C505.407 126.012 505.663 161.646 505.663 161.646Z"
              fill="#DF82BE"
            />
            <path
              d="M505.663 161.646H641.276C641.276 161.646 646.768 163.07 648.077 157.316C649.386 151.562 644.947 148.144 644.947 148.144L621.387 110.545C621.387 110.545 622.183 106.358 611.712 106.871C608.639 107.042 599.192 106.985 587.355 106.871C581.522 106.814 575.148 106.729 568.661 106.643C566.043 106.615 563.397 106.558 560.75 106.529C554.234 106.444 547.832 106.33 541.999 106.244C527.715 106.017 516.959 105.817 516.959 105.817C516.959 105.817 505.976 103.994 505.691 114.989C505.407 126.012 505.663 161.646 505.663 161.646Z"
              fill="url(#paint5_linear)"
            />
            <path
              d="M568.632 106.671L591.168 161.645H609.777L587.327 106.87C581.494 106.813 575.12 106.728 568.632 106.671Z"
              fill="#EFF6FF"
            />
            <path
              d="M541.999 106.244L564.705 161.645H583.314L560.722 106.557C554.234 106.444 547.803 106.358 541.999 106.244Z"
              fill="#EFF6FF"
            />
            <path
              d="M26.2343 277.603L31.2422 307.426L25.6652 327.763L16.1899 326.937V281.221C16.1899 281.221 17.2996 277.319 19.263 277.034C21.2263 276.777 26.2343 277.603 26.2343 277.603Z"
              fill="#1A2D6D"
            />
            <path
              d="M397.678 151.733C397.678 159.794 404.223 166.345 412.275 166.345H471.859C479.912 166.345 486.456 159.794 486.456 151.733V114.932C486.456 106.871 479.912 100.319 471.859 100.319H412.275C404.223 100.319 397.678 106.871 397.678 114.932V151.733Z"
              fill="#182B71"
            />
            <path
              d="M401.406 116.47V150.195C401.406 157.601 407.381 163.583 414.779 163.583H469.355C476.753 163.583 482.729 157.601 482.729 150.195V116.47C482.729 109.093 476.753 103.083 469.355 103.083H414.779C407.381 103.083 401.406 109.065 401.406 116.47Z"
              fill="#1A2D6D"
            />
            <path
              d="M401.406 116.442V150.195C401.406 157.601 407.41 163.583 414.779 163.583H457.945C458.741 162.785 459.453 161.902 460.05 160.905C461.558 158.541 462.412 155.75 462.412 152.73V113.935C462.412 109.691 460.733 105.874 457.973 103.083H414.808C413.186 103.083 411.678 103.368 410.227 103.909C405.077 105.76 401.406 110.688 401.406 116.442Z"
              fill="#DF82BE"
            />
            <path
              d="M401.406 116.442V150.195C401.406 157.601 407.41 163.583 414.779 163.583H457.945C458.741 162.785 459.453 161.902 460.05 160.905C461.558 158.541 462.412 155.75 462.412 152.73V113.935C462.412 109.691 460.733 105.874 457.973 103.083H414.808C413.186 103.083 411.678 103.368 410.227 103.909C405.077 105.76 401.406 110.688 401.406 116.442Z"
              fill="url(#paint6_linear)"
            />
            <path
              d="M417.711 103.082L442.523 163.582H457.945C458.742 162.784 459.453 161.901 460.051 160.904L436.32 103.054H417.711V103.082Z"
              fill="#EFF6FF"
            />
            <path
              d="M401.406 116.441V127.835L416.06 163.554H434.669L410.198 103.88C405.076 105.76 401.406 110.688 401.406 116.441Z"
              fill="#EFF6FF"
            />
            <path
              d="M287.929 151.733C287.929 159.794 294.474 166.345 302.526 166.345H362.11C370.163 166.345 376.707 159.794 376.707 151.733V114.932C376.707 106.871 370.163 100.319 362.11 100.319H302.526C294.474 100.319 287.929 106.871 287.929 114.932V151.733Z"
              fill="#182B71"
            />
            <path
              d="M291.628 116.47V150.195C291.628 157.601 297.604 163.583 305.002 163.583H359.606C366.976 163.583 372.979 157.601 372.979 150.195V116.47C372.979 109.093 367.004 103.083 359.606 103.083H305.002C297.632 103.083 291.628 109.065 291.628 116.47Z"
              fill="#1A2D6D"
            />
            <path
              d="M291.629 116.442V150.195C291.629 157.601 297.632 163.583 305.002 163.583H348.167C348.964 162.785 349.676 161.902 350.273 160.905C351.781 158.541 352.635 155.75 352.635 152.73V113.935C352.635 109.691 350.956 105.874 348.196 103.083H305.031C303.409 103.083 301.901 103.368 300.449 103.909C295.299 105.76 291.629 110.688 291.629 116.442Z"
              fill="#DF82BE"
            />
            <path
              d="M291.629 116.442V150.195C291.629 157.601 297.632 163.583 305.002 163.583H348.167C348.964 162.785 349.676 161.902 350.273 160.905C351.781 158.541 352.635 155.75 352.635 152.73V113.935C352.635 109.691 350.956 105.874 348.196 103.083H305.031C303.409 103.083 301.901 103.368 300.449 103.909C295.299 105.76 291.629 110.688 291.629 116.442Z"
              fill="url(#paint7_linear)"
            />
            <path
              d="M307.932 103.082L332.745 163.582H348.167C348.964 162.784 349.675 161.901 350.272 160.904L326.57 103.054H307.932V103.082Z"
              fill="#EFF6FF"
            />
            <path
              d="M291.627 116.441V127.835L306.281 163.554H324.891L300.42 103.88C295.298 105.76 291.627 110.688 291.627 116.441Z"
              fill="#EFF6FF"
            />
            <path
              d="M184.043 151.733C184.043 159.794 190.587 166.345 198.64 166.345H258.223C266.276 166.345 272.82 159.794 272.82 151.733V114.932C272.82 106.871 266.276 100.319 258.223 100.319H198.64C190.587 100.319 184.043 106.871 184.043 114.932V151.733Z"
              fill="#182B71"
            />
            <path
              d="M187.77 116.47V150.195C187.77 157.601 193.746 163.583 201.144 163.583H255.719C263.117 163.583 269.093 157.601 269.093 150.195V116.47C269.093 109.093 263.117 103.083 255.719 103.083H201.144C193.746 103.083 187.77 109.065 187.77 116.47Z"
              fill="#1A2D6D"
            />
            <path
              d="M187.742 116.442V150.195C187.742 157.003 192.835 162.643 199.408 163.44C199.977 163.526 200.546 163.583 201.115 163.583H244.309C244.366 163.526 244.423 163.469 244.48 163.383C247.155 160.62 248.748 156.861 248.748 152.73V113.935C248.748 109.691 247.069 105.874 244.309 103.083H201.144C198.583 103.083 196.164 103.795 194.116 105.077C190.303 107.441 187.742 111.657 187.742 116.442Z"
              fill="#DF82BE"
            />
            <path
              d="M187.742 116.442V150.195C187.742 157.003 192.835 162.643 199.408 163.44C199.977 163.526 200.546 163.583 201.115 163.583H244.309C244.366 163.526 244.423 163.469 244.48 163.383C247.155 160.62 248.748 156.861 248.748 152.73V113.935C248.748 109.691 247.069 105.874 244.309 103.083H201.144C198.583 103.083 196.164 103.795 194.116 105.077C190.303 107.441 187.742 111.657 187.742 116.442Z"
              fill="url(#paint8_linear)"
            />
            <path
              d="M201.115 103.083L225.927 163.583H244.28C244.337 163.526 244.394 163.469 244.451 163.383L219.724 103.083H201.115Z"
              fill="#EFF6FF"
            />
            <path
              d="M187.742 116.442V135.014L199.408 163.441C199.977 163.526 200.546 163.583 201.115 163.583H218.074L194.087 105.077C190.303 107.441 187.742 111.657 187.742 116.442Z"
              fill="#EFF6FF"
            />
            <path
              d="M76.8835 151.733C76.8835 159.794 83.428 166.345 91.4806 166.345H151.064C159.117 166.345 165.661 159.794 165.661 151.733V114.932C165.661 106.871 159.117 100.319 151.064 100.319H91.4806C83.428 100.319 76.8835 106.871 76.8835 114.932V151.733Z"
              fill="#182B71"
            />
            <path
              d="M80.6108 116.47V150.195C80.6108 157.601 86.5862 163.583 93.9844 163.583H148.588C155.986 163.583 161.962 157.601 161.962 150.195V116.47C161.962 109.093 155.986 103.083 148.588 103.083H93.9844C86.5862 103.083 80.6108 109.065 80.6108 116.47Z"
              fill="#1A2D6D"
            />
            <path
              d="M80.611 116.47V150.195C80.611 157.601 86.5864 163.583 93.9846 163.583H137.178C139.938 160.791 141.617 156.974 141.617 152.73V113.935C141.617 109.691 139.938 105.874 137.178 103.083H93.9846C86.5864 103.083 80.611 109.065 80.611 116.47Z"
              fill="#DF82BE"
            />
            <path
              d="M80.611 116.47V150.195C80.611 157.601 86.5864 163.583 93.9846 163.583H137.178C139.938 160.791 141.617 156.974 141.617 152.73V113.935C141.617 109.691 139.938 105.874 137.178 103.083H93.9846C86.5864 103.083 80.611 109.065 80.611 116.47Z"
              fill="url(#paint9_linear)"
            />
            <path
              d="M78.875 318.022C78.875 324.431 77.1962 328.903 67.4648 329.729C57.7049 330.555 35.7097 329.159 35.7097 329.159C35.7097 329.159 26.5189 329.159 24.2994 325.826C22.08 322.494 19.8322 317.452 19.8322 317.452C19.8322 317.452 18.4379 306.03 23.7304 304.891C29.0229 303.78 36.2788 303.495 36.2788 303.495C36.2788 303.495 44.0753 307.967 49.0832 307.682C54.0912 307.397 71.0785 307.967 71.0785 307.967C71.0785 307.967 78.875 309.676 78.875 318.022Z"
              fill="#1A2D6D"
            />
            <path
              d="M44.3312 312.181C42.2825 314.033 40.433 312.751 37.929 309.39C35.425 306.057 23.1611 292.385 23.1611 292.385C23.1611 292.385 17.2996 287.913 20.0881 284.581C22.8766 281.248 28.1691 287.942 28.1691 287.942L42.6524 306.342C42.6809 306.314 47.1198 309.675 44.3312 312.181Z"
              fill="#1A2D6D"
            />
            <path
              d="M145.458 236.443H94.3824C94.3824 236.443 96.4311 239.235 98.6505 239.035C100.87 238.836 140.991 239.035 140.991 239.035C140.991 239.035 144.889 237.925 145.458 236.443Z"
              fill="#1A2D6D"
            />
            <path
              d="M145.458 228.61H94.3824C94.3824 228.61 96.4311 231.402 98.6505 231.231C100.87 231.031 140.991 231.231 140.991 231.231C140.991 231.231 144.889 230.12 145.458 228.61Z"
              fill="#1A2D6D"
            />
            <path
              d="M145.458 220.805H94.3824C94.3824 220.805 96.4311 223.596 98.6505 223.397C100.87 223.197 140.991 223.397 140.991 223.397C140.991 223.397 144.889 222.314 145.458 220.805Z"
              fill="#1A2D6D"
            />
            <path
              d="M145.458 213.001H94.3824C94.3824 213.001 96.4311 215.792 98.6505 215.593C100.87 215.394 140.991 215.593 140.991 215.593C140.991 215.593 144.889 214.511 145.458 213.001Z"
              fill="#1A2D6D"
            />
            <path
              d="M145.458 205.196H94.3824C94.3824 205.196 96.4311 207.988 98.6505 207.817C100.87 207.617 140.991 207.817 140.991 207.817C140.991 207.817 144.889 206.706 145.458 205.196Z"
              fill="#1A2D6D"
            />
            <path
              d="M145.458 197.392H94.3824C94.3824 197.392 96.4311 200.183 98.6505 199.984C100.87 199.784 140.991 199.984 140.991 199.984C140.991 199.984 144.889 198.873 145.458 197.392Z"
              fill="#1A2D6D"
            />
            <path
              d="M145.458 189.587H94.3824C94.3824 189.587 96.4311 192.378 98.6505 192.179C100.87 191.98 140.991 192.179 140.991 192.179C140.991 192.179 144.889 191.068 145.458 189.587Z"
              fill="#1A2D6D"
            />
            <path
              d="M499.716 172.212L41.4579 168.082"
              stroke="#DBAC00"
              strokeWidth="0.6888"
              strokeMiterlimit="10"
            />
            <path
              d="M59.7537 96.1328H631.431"
              stroke="#DBAC00"
              strokeWidth="0.6888"
              strokeMiterlimit="10"
            />
            <path
              d="M80.0134 136.038H162.986V141.934H80.0134V136.038Z"
              fill="#CED5DD"
            />
            <path
              d="M80.0134 147.146H162.986V153.043H80.0134V147.146Z"
              fill="#CED5DD"
            />
            <path
              d="M227.028 62.8638C227.028 65.5983 228.081 67.8485 229.362 67.8485H282.685C283.966 67.8485 285.019 65.6268 285.019 62.8638V29.4523C285.019 26.7178 283.966 24.4961 282.685 24.4961H229.333C228.053 24.4961 227 26.7178 227 29.4523V62.8638H227.028Z"
              fill="#D181B3"
            />
            <path
              d="M227.028 62.8638C227.028 65.5983 228.081 67.8485 229.362 67.8485H282.685C283.966 67.8485 285.019 65.6268 285.019 62.8638V29.4523C285.019 26.7178 283.966 24.4961 282.685 24.4961H229.333C228.053 24.4961 227 26.7178 227 29.4523V62.8638H227.028Z"
              fill="url(#paint10_linear)"
            />
            <path
              d="M283.197 11.9065V61.1835C283.197 65.2282 286.498 68.5039 290.539 68.5039H458.676C462.716 68.5039 465.988 65.2282 465.988 61.1835V11.9065C465.988 7.86174 462.716 4.55762 458.676 4.55762H290.539C286.498 4.5861 283.197 7.86174 283.197 11.9065Z"
              fill="#5A7EF2"
            />
            <path
              d="M283.197 11.9065V52.9802H465.96V11.9065C465.96 7.86174 462.688 4.55762 458.647 4.55762H290.51C286.498 4.5861 283.197 7.86174 283.197 11.9065Z"
              fill="url(#paint11_linear)"
            />
            <path
              d="M465.988 45.1182H284.99"
              stroke="#FAFBFC"
              strokeWidth="0.6888"
              strokeMiterlimit="10"
            />
            <path
              d="M464.68 30.7344H478.395V41.188H464.68V30.7344Z"
              fill="#1A2D6D"
            />
            <path d="M361.419 0H382.987V68.6746H361.419V0Z" fill="#F2F2F2" />
            <path
              d="M361.419 0H382.987V68.6746H361.419V0Z"
              fill="url(#paint12_linear)"
            />
            <path
              d="M251.357 20.6787H265.072V68.2752H251.357V20.6787Z"
              fill="#CED5DD"
            />
            <path
              d="M251.357 20.6787H265.072V68.2752H251.357V20.6787Z"
              fill="url(#paint13_linear)"
            />
            <path
              d="M423.165 31.3896H431.673V47.4261H423.165V31.3896Z"
              fill="#CED5DD"
            />
            <path
              d="M420.205 51.728C420.205 54.7758 422.652 57.2254 425.697 57.2254H428.742C431.786 57.2254 434.233 54.7473 434.233 51.728V45.4046C434.233 42.3568 431.786 39.9072 428.742 39.9072H425.697C422.652 39.9072 420.205 42.3568 420.205 45.4046V51.728Z"
              fill="#DBAC00"
            />
            <path
              d="M308.181 31.3896H316.688V47.4261H308.181V31.3896Z"
              fill="#CED5DD"
            />
            <path
              d="M305.221 51.728C305.221 54.7758 307.668 57.2254 310.713 57.2254H313.757C316.774 57.2254 319.249 54.7473 319.249 51.728V45.4046C319.249 42.3568 316.774 39.9072 313.757 39.9072H310.713C307.668 39.9072 305.221 42.3568 305.221 45.4046V51.728Z"
              fill="#DBAC00"
            />
          </g>
          <g opacity="0.2">
            <path
              d="M331.089 199H341.596C346.953 199 350.735 201.697 350.735 206.482C350.735 209.178 349.406 211.508 347.163 212.693V212.774C350.405 213.715 351.94 216.656 351.94 219.598C351.94 225.4 347.206 228.016 341.763 228.016H331.089V199ZM341.639 210.854C343.964 210.854 345.293 209.22 345.293 207.136C345.293 205.051 344.006 203.54 341.553 203.54H336.446V210.857H341.639V210.854ZM342.179 223.484C344.92 223.484 346.459 221.728 346.459 219.272C346.459 216.863 344.881 215.103 342.179 215.103H336.446V223.48H342.179V223.484Z"
              fill="#FF0000"
            />
            <path
              d="M367.02 214.942H367.933V214.655C367.933 211.916 366.149 210.975 363.945 210.975C361.869 210.975 359.751 211.832 358.048 212.98L356.097 209.262C357.842 207.873 361.247 206.688 364.404 206.688C369.928 206.688 373.208 209.713 373.208 214.984V228.023H368.307V226.268C368.307 225.411 368.431 224.757 368.431 224.757H368.349C367.063 226.964 364.528 228.517 361.663 228.517C357.842 228.517 354.686 226.065 354.686 222.263C354.686 216.005 362.328 214.942 367.02 214.942ZM363.117 224.546C366.068 224.546 367.976 221.605 367.976 219.069V218.495H367.063C364.404 218.495 359.918 218.862 359.918 221.808C359.918 223.196 360.999 224.546 363.117 224.546Z"
              fill="#FF0000"
            />
            <path
              d="M378.771 222.011C380.349 223.442 382.674 224.299 384.792 224.299C386.662 224.299 387.743 223.522 387.743 222.214C387.743 218.944 377.235 219.762 377.235 212.935C377.235 208.849 380.889 206.681 385.336 206.681C387.871 206.681 390.53 207.377 392.481 209.052L390.53 212.69C389.282 211.626 387.039 210.892 385.173 210.892C383.346 210.892 382.223 211.588 382.223 212.896C382.223 216.209 392.73 215.268 392.73 222.092C392.73 225.771 389.573 228.51 384.714 228.51C381.764 228.51 378.607 227.531 376.407 225.446L378.771 222.011Z"
              fill="#FF0000"
            />
            <path
              d="M417.492 199H428.874C434.398 199 438.262 202.802 438.262 208.44C438.262 214.082 434.398 218.003 428.874 218.003H422.853V228.016H417.496V199H417.492ZM427.875 213.428C430.989 213.428 432.82 211.466 432.82 208.44C432.82 205.457 430.993 203.536 427.961 203.536H422.853V213.428H427.875Z"
              fill="#FF0000"
            />
            <path
              d="M452.49 214.942H453.403V214.655C453.403 211.916 451.619 210.975 449.415 210.975C447.339 210.975 445.22 211.832 443.518 212.98L441.566 209.262C443.312 207.873 446.717 206.688 449.873 206.688C455.397 206.688 458.678 209.713 458.678 214.984V228.023H453.776V226.268C453.776 225.411 453.901 224.757 453.901 224.757H453.819C452.532 226.964 449.998 228.517 447.133 228.517C443.312 228.517 440.155 226.065 440.155 222.263C440.151 216.005 447.798 214.942 452.49 214.942ZM448.587 224.546C451.537 224.546 453.446 221.605 453.446 219.069V218.495H452.532C449.873 218.495 445.388 218.862 445.388 221.808C445.388 223.196 446.468 224.546 448.587 224.546Z"
              fill="#FF0000"
            />
            <path
              d="M465.593 232.231C467.046 232.231 468.5 231.375 469.289 229.535L470.078 227.695L461.149 207.178H467.089L471.532 219.192C471.948 220.294 472.321 222.011 472.321 222.011H472.407C472.407 222.011 472.78 220.378 473.114 219.272L477.266 207.174H483L473.569 231.168C472.115 234.97 469.041 236.603 465.927 236.603C463.392 236.603 461.523 235.253 461.523 235.253L463.268 231.371C463.268 231.371 464.43 232.231 465.593 232.231Z"
              fill="#FF0000"
            />
            <path
              d="M328.1 226.085C328.1 226.066 328.1 226.043 328.104 226.024C328.131 225.339 327.506 224.815 326.829 224.987C326.456 225.083 325.469 225.393 325.235 225.412C324.975 225.435 326.456 220.868 326.864 217.479C327.136 215.237 326.938 213.512 325.457 213.979C319.805 217.226 316.295 222.539 311.066 226.211C312.644 219.885 312.73 216.787 312.162 216.473C311.529 216.125 310.083 219.261 309.006 225.274C307.043 236.24 321.344 219.162 324.365 217.28C323.552 221.671 323.432 224.44 322.487 226.1C322.153 226.686 317.504 229.386 313.049 232.997C309.807 235.628 306.168 240.161 304.318 244.304C302.398 248.599 302.339 252.405 306.405 252.952C308.267 253.201 310.141 252.455 311.568 251.288C318.701 245.451 322.312 233.896 323.801 229.283C323.949 228.824 324.015 228.659 324.081 228.422C324.124 228.323 326.044 227.432 327.373 227.034C327.805 226.911 328.085 226.525 328.1 226.085ZM307.914 250.963C307.529 251.238 307.066 251.445 306.584 251.491C302.81 251.862 308.26 242.211 309.146 240.677C311 237.962 313.22 235.613 315.595 233.563C316.47 232.809 321.177 229.593 321.181 229.91C317.542 237.262 314.996 245.845 307.914 250.963Z"
              fill="#FF0000"
            />
            <path
              d="M304.019 228.74C303.443 229.237 302.537 228.858 302.456 228.109C302.359 227.236 302.526 226.108 302.825 224.896C304.069 219.847 307.583 213.294 303.661 217.196C302.176 218.672 298.499 224.303 297.612 225.672C296.602 227.233 295.451 228.353 294.176 226.865C295.043 223.786 296.407 220.768 296.504 217.028C296.559 214.889 288.594 225.026 286.775 228.17C285.639 230.132 283.004 229.956 283 228.158C284.489 224.899 283.49 217.28 286.973 216.484C287.33 218.642 285.616 225.022 285.667 225.202C285.748 225.5 286.273 224.597 287.144 223.144C288.854 219.644 293.068 215.28 295.816 214.568C297.954 214.017 299.21 215.677 297.713 221.675C299.673 218.806 304.123 214.216 306.522 213.822C307.778 213.616 308.469 214.557 307.956 217.49C307.781 218.512 306.199 226.865 304.019 228.74Z"
              fill="#FF0000"
            />
            <path
              d="M396.407 226.422V227.99H410.561C412.221 227.99 413.566 226.666 413.566 225.033V223.465H399.412C397.752 223.465 396.407 224.788 396.407 226.422Z"
              fill="#FF0000"
            />
            <path
              d="M396.407 210.12V211.688H410.561C412.221 211.688 413.566 210.365 413.566 208.731V207.163H399.412C397.752 207.163 396.407 208.487 396.407 210.12Z"
              fill="#FF0000"
            />
            <path
              d="M396.407 218.27V219.838H410.561C412.221 219.838 413.566 218.515 413.566 216.882V215.313H399.412C397.752 215.313 396.407 216.637 396.407 218.27Z"
              fill="#FF0000"
            />
          </g>
          <g>
            <path
              opacity="0.2"
              d="M154 331.258V332.827H168.154C169.813 332.827 171.158 331.503 171.158 329.87V328.302H157.005C155.345 328.302 154 329.625 154 331.258Z"
              fill="white"
            />
            <path
              opacity="0.2"
              d="M556 331.258V332.827H570.154C571.813 332.827 573.158 331.503 573.158 329.87V328.302H559.005C557.345 328.302 556 329.625 556 331.258Z"
              fill="white"
            />
            <path
              opacity="0.2"
              d="M154 314.957V316.525H168.154C169.813 316.525 171.158 315.202 171.158 313.568V312H157.005C155.345 312 154 313.323 154 314.957Z"
              fill="white"
            />
            <path
              opacity="0.2"
              d="M556 314.957V316.525H570.154C571.813 316.525 573.158 315.202 573.158 313.568V312H559.005C557.345 312 556 313.323 556 314.957Z"
              fill="white"
            />
            <path
              opacity="0.2"
              d="M154 323.107V324.675H168.154C169.813 324.675 171.158 323.352 171.158 321.719V320.15H157.005C155.345 320.15 154 321.474 154 323.107Z"
              fill="white"
            />
            <path
              opacity="0.2"
              d="M556 323.107V324.675H570.154C571.813 324.675 573.158 323.352 573.158 321.719V320.15H559.005C557.345 320.15 556 321.474 556 323.107Z"
              fill="white"
            />
          </g>

          <g>
            <path
              className={styles.dirt1}
              d="M58.3212 361.43C58.3212 361.755 58.0528 362.024 57.727 362.024C57.4011 362.024 57.1328 361.755 57.1328 361.43C57.1328 361.104 57.4011 360.836 57.727 360.836C58.0528 360.836 58.3212 361.104 58.3212 361.43Z"
              fill="url(#paint14_linear)"
            />
            <path
              className={styles.dirt2}
              d="M57.4877 371.822C57.4877 372.483 56.951 373.02 56.2897 373.02C55.6285 373.02 55.0918 372.483 55.0918 371.822C55.0918 371.161 55.6285 370.625 56.2897 370.625C56.951 370.635 57.4877 371.161 57.4877 371.822Z"
              fill="url(#paint15_linear)"
            />
            <path
              className={styles.dirt3}
              d="M71.8245 360.472C71.8245 360.539 71.7671 360.597 71.7096 360.597C71.6425 360.597 71.585 360.539 71.585 360.472C71.585 360.405 71.6425 360.357 71.7096 360.357C71.7766 360.357 71.8245 360.415 71.8245 360.472Z"
              fill="url(#paint16_linear)"
            />
            <path
              className={styles.dirt4}
              d="M95.9484 343.973C95.9484 345.065 95.0667 345.946 93.9742 345.946C92.8817 345.946 92 345.065 92 343.973C92 342.881 92.8817 342 93.9742 342C95.0667 342 95.9484 342.881 95.9484 343.973Z"
              fill="url(#paint17_linear)"
            />
            <path
              className={styles.dirt5}
              d="M92.7447 366.449C92.7447 367.311 92.0451 368.001 91.1922 368.001C90.3297 368.001 89.6396 367.302 89.6396 366.449C89.6396 365.587 90.3392 364.897 91.1922 364.897C92.0547 364.897 92.7447 365.587 92.7447 366.449Z"
              fill="url(#paint18_linear)"
            />
            <path
              className={styles.dirt6}
              d="M114.469 369.734C114.469 370.691 113.693 371.467 112.735 371.467C111.776 371.467 111 370.691 111 369.734C111 368.776 111.776 368 112.735 368C113.693 368 114.469 368.776 114.469 369.734Z"
              fill="url(#paint19_linear)"
            />
            <path
              className={styles.dirt7}
              d="M108.404 352.292C108.404 352.723 108.059 353.068 107.628 353.068C107.197 353.068 106.852 352.723 106.852 352.292C106.852 351.861 107.197 351.517 107.628 351.517C108.059 351.517 108.404 351.861 108.404 352.292Z"
              fill="url(#paint20_linear)"
            />
            <path
              className={styles.dirt8}
              d="M50.9135 344.649C50.9135 345.214 50.4631 345.664 49.8977 345.664C49.3323 345.664 48.8818 345.214 48.8818 344.649C48.8818 344.084 49.3323 343.634 49.8977 343.634C50.4535 343.634 50.9135 344.084 50.9135 344.649Z"
              fill="url(#paint21_linear)"
            />
            <path
              className={styles.dirt9}
              d="M20.1883 353.068C20.1883 353.394 19.92 353.662 19.5942 353.662C19.2683 353.662 19 353.394 19 353.068C19 352.743 19.2683 352.475 19.5942 352.475C19.92 352.475 20.1883 352.743 20.1883 353.068Z"
              fill="url(#paint22_linear)"
            />
            <path
              className={styles.dirt10}
              d="M134.833 372.916C134.833 373.969 133.98 374.831 132.917 374.831C131.863 374.831 131 373.979 131 372.916C131 371.862 131.853 371 132.917 371C133.98 371 134.833 371.862 134.833 372.916Z"
              fill="url(#paint23_linear)"
            />
            <path
              className={styles.dirt11}
              d="M83.8651 350.931C83.8651 352.55 82.5522 353.862 80.9325 353.862C79.3129 353.862 78 352.55 78 350.931C78 349.312 79.3129 348 80.9325 348C82.5522 348 83.8651 349.312 83.8651 350.931Z"
              fill="url(#paint24_linear)"
            />
          </g>

          <defs>
            <radialGradient
              id="paint0_radial"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(385.5 368.492) rotate(180) scale(368.789 31.3027)"
            >
              <stop />
              <stop offset="0.9987" stopOpacity="0" />
            </radialGradient>
            <linearGradient
              id="paint1_linear"
              x1="162.103"
              y1="355.787"
              x2="162.103"
              y2="287.088"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.9987" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint2_linear"
              x1="562.079"
              y1="355.788"
              x2="562.079"
              y2="287.087"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.9987" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint3_linear"
              x1="162.528"
              y1="266.963"
              x2="162.528"
              y2="315.654"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E087BE" />
              <stop offset="0.9987" stopColor="#E087BE" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint4_linear"
              x1="564.709"
              y1="237.76"
              x2="564.709"
              y2="328.417"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E087BE" />
              <stop offset="0.9987" stopColor="#E087BE" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint5_linear"
              x1="576.935"
              y1="175.931"
              x2="576.935"
              y2="90.9004"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="0.9987" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint6_linear"
              x1="431.897"
              y1="170.698"
              x2="431.897"
              y2="82.9045"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="0.9987" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint7_linear"
              x1="322.135"
              y1="173.313"
              x2="322.135"
              y2="85.5899"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="0.9987" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint8_linear"
              x1="218.253"
              y1="170.698"
              x2="218.253"
              y2="86.9742"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="0.9987" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint9_linear"
              x1="111.11"
              y1="178.548"
              x2="111.11"
              y2="93.4882"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="0.9987" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint10_linear"
              x1="256.006"
              y1="71.2879"
              x2="256.006"
              y2="27.3562"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="0.9987" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint11_linear"
              x1="374.582"
              y1="98.7574"
              x2="374.582"
              y2="7.82101"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="0.9987" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint12_linear"
              x1="372.219"
              y1="90.649"
              x2="372.219"
              y2="52.8524"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E087BE" />
              <stop offset="0.9987" stopColor="#E087BE" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint13_linear"
              x1="258.21"
              y1="83.5132"
              x2="258.21"
              y2="57.3089"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E087BE" />
              <stop offset="0.9987" stopColor="#E087BE" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint14_linear"
              x1="57.727"
              y1="360.836"
              x2="57.727"
              y2="362.024"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint15_linear"
              x1="56.2897"
              y1="370.625"
              x2="56.2897"
              y2="373.02"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint16_linear"
              x1="71.7048"
              y1="360.357"
              x2="71.7048"
              y2="360.597"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint17_linear"
              x1="93.9742"
              y1="342"
              x2="93.9742"
              y2="345.946"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint18_linear"
              x1="91.1922"
              y1="364.897"
              x2="91.1922"
              y2="368.001"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint19_linear"
              x1="112.735"
              y1="368"
              x2="112.735"
              y2="371.467"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint20_linear"
              x1="107.628"
              y1="351.517"
              x2="107.628"
              y2="353.068"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint21_linear"
              x1="49.8977"
              y1="343.634"
              x2="49.8977"
              y2="345.664"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint22_linear"
              x1="19.5942"
              y1="352.475"
              x2="19.5942"
              y2="353.662"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint23_linear"
              x1="132.917"
              y1="371"
              x2="132.917"
              y2="374.831"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <linearGradient
              id="paint24_linear"
              x1="80.9325"
              y1="348"
              x2="80.9325"
              y2="353.862"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#666666" />
              <stop offset="1" stopColor="#242424" />
            </linearGradient>
            <clipPath id="clip0">
              <rect
                width="771"
                height="381"
                fill="white"
                transform="matrix(-1 0 0 1 771 0)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className={styles.textWrap}>
        <h1 className={styles.title}>Let's take a tour</h1>
        <p className={styles.subtitle}>
          Are you overwhelmed by payroll, invoicing & billing? <br />
          Are compliance and EOR requirements keeping you up at night?
        </p>
        <p className={styles.capture}>We got you covered!</p>

        <div>
          <Button
            className={styles.transparentBtn}
            size="large"
            onClick={handleBack}
          >
            Back
          </Button>

          <Button
            className={styles.nextBtn}
            type="primary"
            size="large"
            onClick={handleNext}
          >
            Go
          </Button>
        </div>
      </div>
    </div>
  );
}
